import { useState } from "react";
import { Box, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Button, Radio } from "@mui/material";
import { useQuickFilter } from "../../layouts/report/ReportDetailsContext";
import filterIcon from '../../assets/icons/filter-icon.svg'
import CloseIcon from '../../assets/icons/closeicon.svg'

export function ChartsQuickFilter() {
  const [ShowQuickFilter, setShowQuickFilter] = useState(false)
  const [quickFilterSelectedIndex, setQuickFilterSelectedIndex] = useState(0);
  const [quickFilterTemp, setQuickFilterTemp] = useState({})
  const visiblefilter = event => {
    setShowQuickFilter(true);
    document.body.classList.add("overflowY-hidden");
  };
  const { quickFilterList, updateQuickFilter } = useQuickFilter();
  if (!quickFilterList || !quickFilterList.length) return null;

  //console.log('quickFilterList', quickFilterList)
  function onFilterChange(event, conditionIndex, filterIndex) {
    event.stopPropagation();
    event.preventDefault();
    const filter = quickFilterList[filterIndex];
    if (filter.listType === "SingleSelect") {
      filter.conditions.forEach((condition, index) => {
        filter.conditions[index].selected = false;
        if (index === conditionIndex) {
          filter.conditions[index].selected = true;
        }
      })
    } else {
      filter.conditions[conditionIndex].selected = filter.conditions[conditionIndex]?.selected === true ? false : true;
    }
    updateQuickFilter({ ...filter })
  }

  const onMobileFilterChange = (event, conditionIndex, filterIndex) => {
    const filter = quickFilterList[filterIndex];
    if (filter.listType === "SingleSelect") {
      filter.conditions.forEach((condition, index) => {
        filter.conditions[index].selected = false;
        if (index === conditionIndex) {
          filter.conditions[index].selected = true;
        }
      })
    } else {
      filter.conditions[conditionIndex].selected = filter.conditions[conditionIndex]?.selected === true ? false : true;
    }
    setQuickFilterTemp({ ...filter })
  }

  const onMobileApplyQuickFilter = () => {
    updateQuickFilter({ ...quickFilterTemp })
    setShowQuickFilter(false)
  }

  const onMobileQuickFilterClear = () => {
    //console.log(quickFilterList)
    let filterList = quickFilterList.map(obj => {
      obj.conditions = obj.conditions.map(cond => {
        cond.selected = false
        return cond
      })
      return obj
    })
    updateQuickFilter(filterList, true)
    setShowQuickFilter(false)
  }

  return (
    <>
      {(window.innerWidth > 1023) ?
        <Box className="CompareBy-reports" >
          {
            quickFilterList.map((quickFilter, filterIndex) => {
              const isSingleSelect = quickFilter?.listType === "SingleSelect";
              return (
                <div className="quick-filters-chart-filter-item" key={`quick-filter-${quickFilter?.member}`}>
                  {/* // title */}
                  <h3 className="" >{quickFilter?.label}</h3>
                  {/* // filter */}
                  <List>
                    {quickFilter?.conditions.map((condition, conditionIndex) => {
                      return (
                        <ListItem
                          disablePadding
                          key={`quick-filter-${quickFilter?.member}-condition-${conditionIndex}`}
                          onClick={(event) => onFilterChange(event, conditionIndex, filterIndex)}
                        >
                          <ListItemButton
                            selected={Boolean(condition.selected)}
                          >
                            <ListItemIcon>
                              {
                                isSingleSelect
                                  ? (
                                    <Radio
                                      checked={Boolean(condition.selected)}
                                      value={condition}
                                      name="filter"
                                      inputProps={{ 'aria-label': 'filter' }}
                                    />
                                  )
                                  : (
                                    <Checkbox
                                      checked={Boolean(condition.selected)}
                                      value={condition}
                                      name="filter"
                                      inputProps={{ 'aria-label': 'filter' }}
                                    />
                                  )
                              }
                            </ListItemIcon>
                            <ListItemText primary={condition.label} />
                          </ListItemButton>
                        </ListItem>
                      )
                    })
                    }
                  </List>
                </div>
              )
            })
          }
        </Box >
      :
        <div className="CompareBy-reports-mweb">
          <div className="filter-button-container">
            <Button className="filter-button" onClick={visiblefilter} >
              <img src={filterIcon} alt="filtericon" />
              Filter
            </Button>
          </div>
          {ShowQuickFilter &&
            <div className="filter-main-container">
              <div className="filter-container">
                <div className="filter-mobile-header">
                  <div className="filter_header">
                    <span>Filter</span>
                    <span onClick={() => {setShowQuickFilter(false);document.body.classList.remove("overflowY-hidden");}}> <img src={CloseIcon} className="em-close"></img> </span>
                  </div>
                </div>
                <div className="filter-body-div">
                  <div className="keys-container">
                    {
                      quickFilterList.map((quickFilter, filterIndex) => {
                        const isSingleSelect = quickFilter?.listType === "SingleSelect";
                        return (
                          <div key={`quick-filter-${quickFilter?.member}`}>
                            <h3 className={quickFilterSelectedIndex == filterIndex ? "key selected" : "key"} onClick={() => setQuickFilterSelectedIndex(filterIndex)}>{quickFilter?.label}</h3>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="value-container">
                    {
                      quickFilterList.map((quickFilter, filterIndex) => {
                        const isSingleSelect = quickFilter?.listType === "SingleSelect";
                        return (
                          <div className={`quick-filter-list ` + ((quickFilterSelectedIndex === filterIndex) ? 'quicker-filter-list-selected' : ``)} key={`quick-filter-${quickFilter?.member}`}>
                            <List>
                              {quickFilter?.conditions.map((condition, conditionIndex) => {
                                return (
                                  <ListItem
                                    disablePadding
                                    key={`quick-filter-${quickFilter?.member}-condition-${conditionIndex}`}
                                    onClick={(event) => onMobileFilterChange(event, conditionIndex, filterIndex)}
                                  >
                                    <ListItemButton
                                      selected={Boolean(condition.selected)}
                                    >
                                      <ListItemIcon>
                                        <Checkbox
                                          checked={Boolean(condition.selected)}
                                          value={condition}
                                          name="filter"
                                          inputProps={{ 'aria-label': 'filter' }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText primary={condition.label} />
                                    </ListItemButton>
                                  </ListItem>
                                )
                              })
                              }
                            </List>

                          </div>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="button-containers">
                  <Button className="clearBtn" onClick={onMobileQuickFilterClear}>Clear All</Button>
                  <Button className="applyBtn" onClick={onMobileApplyQuickFilter}>Apply</Button>
                </div>

              </div>
            </div>
          }
        </div>

      }
    </>

  )
}